import * as React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { CustomerPickerReducer } from './customer-picker.reducer';
import { CustomerPickerContainer, CustomerPickerContainerProperties } from './_components/customer-picker.container';

const store = createStore(CustomerPickerReducer, applyMiddleware(thunk));

export class CustomerPicker extends React.Component<CustomerPickerContainerProperties> {
  render() {
    return (
      <Provider store={store}>
        <CustomerPickerContainer {...this.props} />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/customer/_components/customer-picker/customer-picker.tsx